import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class StopRespinRollingState extends BaseState {
    constructor(stateData) {
        super(stateData);
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('reelsContainer:reelsStopped', this.onRespinReelsStopped, this);
    }

    onRespinReelsStopped() {
        if (this.active) {
            this.complete();
        }
    }
}